import { queryCache, useQuery } from "react-query"

import { BillingType } from "routes/Base/Admin/MarketSettings/List/BillingTypes/types"
import { BillingTypeTuple } from "./cells/BillingTypeCell"
import { ChangedPlanRecord } from "./types"
import { MediaType } from "routes/Base/Admin/GlobalMediaTypes/types"
import { Paginated } from "api/types"
import { fetchBillingTypes } from "api/billingtypes"
import { get } from "lodash/fp"
import { useParams } from "react-router-dom"

const VIEWABLE_SEMANTICS_PER_BILLING_TYPE: {
  [key: string]: Array<BillingType["semanticCode"]>
} = {
  clientCost: ["paid", "bonus", "contranoac", "contraac"],
  mediaValue: ["paid", "bonus", "contranoac", "contraac"],
  mediaCommissions: ["paid", "contranoac", "contraac"],
  passthroughCosts: ["paid", "contranoac", "contraac"],
  agencyCommissions: ["paid", "contraac"],
  fees: ["paid", "contranoac", "contraac"],
  taxes: ["paid", "contranoac", "contraac"],
}

export function useBillingTypesRules(
  row: ChangedPlanRecord,
  primaryKey: string,
  semantic?: string,
) {
  const { id: planId } = useParams<{ id: string }>()

  const mtps = new URLSearchParams([
    ["configScope", "MEDIA_PLAN"],
    ["configOwnerId", planId],
  ])

  const mediaTypes = queryCache.getQueryData<Paginated<MediaType>>([
    "media-types",
    mtps.toString(),
  ])

  const { data: billingTypes } = useQuery(
    ["billing-types"],
    fetchBillingTypes,
    {
      initialData: queryCache.getQueryData(["billing-types"]),
      refetchOnMount: !queryCache.getQueryData(["billing-types"]),
    },
  )

  const mediaTypeId = row?.mediaId || row?.ancestorMediaId

  const defaultFieldIds = mediaTypes?.data?.find(
    (mt) => mt.id === mediaTypeId,
  )?.defaultFieldIdBySemantic

  const billingTypeTuple = !!defaultFieldIds?.billingType
    ? (get(
        `${primaryKey}.${defaultFieldIds.billingType}`,
        row,
      ) as BillingTypeTuple)
    : undefined

  const billingType = billingTypes?.find(
    (bt) => bt.id === billingTypeTuple?.billingTypeId,
  )

  const validBillingTypes = !!semantic
    ? VIEWABLE_SEMANTICS_PER_BILLING_TYPE?.[semantic]
    : undefined
  const mustApplyRule = !!billingType && !!semantic && !!validBillingTypes

  if (!mustApplyRule) {
    return true
  } else {
    return validBillingTypes?.includes(billingType?.semanticCode?.toLowerCase())
  }
}
